// Ticket 28: Leaderboard API

const API_BASE = window.location.origin;

export async function fetchTopGifters(range = 'weekly') {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/stats/leaderboard/top-gifters?range=${range}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to fetch top gifters');
  }
  
  return res.json();
}

export async function fetchMostLoved(range = 'weekly') {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/stats/leaderboard/most-loved?range=${range}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to fetch most loved');
  }
  
  return res.json();
}
